class TkIdsCartAttribute extends HTMLElement {
  static ATTRIBUTE_KEY = 'tk_ids';

  connectedCallback() {
    this.syncing = false;
    this.currentValue = this.decodeEntities(this.dataset.initialValue || '');
    this.sync();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const attributes = event?.cartData?.attributes;
        this.currentValue = attributes
          ? attributes[TkIdsCartAttribute.ATTRIBUTE_KEY] || ''
          : this.currentValue;
        this.sync();
      });
    }
  }

  disconnectedCallback() {
    this.unsubscribe?.();
  }

  decodeEntities(value) {
    if (!value || !value.includes('&')) return value;
    return new DOMParser().parseFromString(value, 'text/html').documentElement.textContent;
  }

  readCookie() {
    const match = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${TkIdsCartAttribute.ATTRIBUTE_KEY}=`));
    if (!match) return '';
    try {
      return decodeURIComponent(match.slice(TkIdsCartAttribute.ATTRIBUTE_KEY.length + 1));
    } catch {
      return match.slice(TkIdsCartAttribute.ATTRIBUTE_KEY.length + 1);
    }
  }

  async sync() {
    if (this.syncing) return;
    const cookieValue = this.readCookie();
    if (!cookieValue || cookieValue === this.currentValue) return;
    this.syncing = true;
    try {
      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [TkIdsCartAttribute.ATTRIBUTE_KEY]: cookieValue } }),
      });
      if (response.ok) this.currentValue = cookieValue;
    } catch {
    } finally {
      this.syncing = false;
    }
  }
}

customElements.define('tk-ids-cart-attribute', TkIdsCartAttribute);
